import { useMemo } from 'react';

import {
    pinwheelStepsGoBack,
    pinwheelStepsSetStep,
} from '@perpay-web/fintech/actions/ui/pinwheel';
import { PINWHEEL_STEPS } from '@perpay-web/fintech/constants/pinwheelConstants';
import { useActionObservableCallback } from '@perpay-web/hooks/useActionObservableCallback';
import { useSteps } from '@perpay-web/hooks/useSteps';
import { hookAction$ } from '@perpay-web/services/singletons';
import { createContextProvider } from '@perpay-web/utils/componentUtils';

const usePinwheelSteps = () => {
    const hook = useSteps(PINWHEEL_STEPS);

    return hook;
};

const providerFactory = (Context) => {
    const Provider = ({ children }) => {
        const hook = usePinwheelSteps();

        useActionObservableCallback(
            hookAction$,
            pinwheelStepsSetStep().type,
            (step) => hook.setStep(step),
        );

        useActionObservableCallback(
            hookAction$,
            pinwheelStepsGoBack().type,
            () => hook.goBack(),
        );

        const contextValue = useMemo(
            () => ({
                step: hook.step,
                setStep: hook.setStep,
                goBack: hook.goBack,
            }),
            [hook.step, hook.setStep, hook.goBack],
        );
        return (
            <Context.Provider value={contextValue}>{children}</Context.Provider>
        );
    };

    return Provider;
};

export const [PinwheelStepsProvider, usePinwheelStepsContext] =
    createContextProvider(providerFactory);
